import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingCompany.css";

export default function CompanyLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing company-landing">

      {/* =====================================================
          NAVBAR
      ====================================================== */}
      <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="logo-img"
          />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>

          <a href="#why" onClick={() => setMenuOpen(false)}>
            Why Nessefy
          </a>

          <a href="#how" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>

          <a href="#community" onClick={() => setMenuOpen(false)}>
            Community
          </a>

        </div>

        <div className="nav-actions">

          <button
            className="nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>
      </nav>


      {/* =====================================================
          HERO
      ====================================================== */}
      <section className="hero company-hero">

        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">

          <p className="hero-badge">
            🏢 BUILT FOR COMPANIES THAT WANT TO GROW
          </p>

          <h1>
            Your Next
            <br />
            Opportunity
            <br />
            <span className="highlight">
              Could Be
              <span> One Connection Away.</span>
            </span>
          </h1>

          <p>
            Put your company in front of ambitious entrepreneurs,
            professionals, investors, founders and builders who can
            help your business grow, collaborate and reach what's next.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-btn"
              onClick={goToRegister}
            >
              🏢 Join Nessefy
              <span className="button-arrow">→</span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="free-points">

            <span>
              <b>✓</b> Free to join
            </span>

            <span>
              <b>✓</b> Build your company presence
            </span>

            <span>
              <b>✓</b> Connect with the ecosystem
            </span>

          </div>

        </div>


        {/* =====================================================
            HERO VISUAL
        ====================================================== */}
        <div className="hero-card company-hero-card">

          <div className="floating-mini-card mini-card-1">

            <h4>🏢 Company Profile</h4>

            <p>
              Put your business in front of the right people
            </p>

          </div>


          <div className="post-card company-post-card">

            <div className="company-network">

              <div className="network-circle network-one">
                👨🏻‍💻
              </div>

              <div className="network-circle network-two">
                👩🏻‍💼
              </div>

              <div className="network-circle network-three">
                💼
              </div>

              <div className="network-line line-one"></div>
              <div className="network-line line-two"></div>
              <div className="network-line line-three"></div>

              <div className="network-center">

                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />

              </div>

            </div>

            <div className="post-card-copy">

              <h3>
                Grow Your Network.
              </h3>

              <p>
                The right people can open the door to the
                next opportunity for your company.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FREE STRIP
      ====================================================== */}
      <section className="free-strip">

        <div className="free-strip-icon">
          ✓
        </div>

        <div>

          <strong>
            Your company can join Nessefy for free.
          </strong>

          <span>
            Create your company presence, discover people,
            share what you do and start connecting.
          </span>

        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =====================================================
          SHOWCASE
      ====================================================== */}
      <section className="showcase">

        <div className="showcase-content">

          <span className="showcase-tag">
            GROW YOUR BUSINESS NETWORK
          </span>

          <h2>
            Your company
            <br />
            shouldn't grow
            <br />
            <span className="showcase-highlight">
              in isolation.
            </span>
          </h2>

          <p>
            Nessefy brings your company into a growing ecosystem
            of entrepreneurs, professionals, freelancers, investors,
            founders and business-minded people.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>

          <div className="showcase-benefits">

            <div>

              <span>01</span>

              <strong>
                Get Discovered
              </strong>

              <p>
                Put your company in front of people who may
                need, support or grow with your business.
              </p>

            </div>


            <div>

              <span>02</span>

              <strong>
                Build Connections
              </strong>

              <p>
                Meet potential partners, talent, clients,
                investors and collaborators.
              </p>

            </div>


            <div>

              <span>03</span>

              <strong>
                Create Opportunities
              </strong>

              <p>
                Turn conversations and relationships into
                partnerships, projects and growth.
              </p>

            </div>

          </div>

        </div>


        <div className="phone-showcase">

          <div className="floating-ui ui-top-left">
            🏢 Company Profile
          </div>

          <div className="floating-ui ui-top-right">
            🤝 Business Connections
          </div>

          <div className="floating-ui ui-bottom-left">
            💼 Find Talent
          </div>

          <div className="floating-ui ui-bottom-right">
            🚀 Find Opportunities
          </div>


          <div className="phone-frame">

            <div className="phone-notch"></div>

            <div className="phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY NESSEFY
      ====================================================== */}
      <section
        id="why"
        className="features"
      >

        <div className="features-header">

          <span className="features-tag">
            WHY COMPANIES JOIN NESSEFY
          </span>

          <h2>
            Your business
            <br />
            is more than a logo.
          </h2>

          <p>
            A company is built by the people around it.
            Nessefy helps you become part of an ecosystem
            where ideas, talent, capital and opportunities meet.
          </p>

        </div>


        <div className="journey-container">

          <div className="journey-card">

            <div className="journey-step">
              01
            </div>

            <div className="journey-icon">
              👀
            </div>

            <h3>
              Be Discovered
            </h3>

            <p>
              Build a presence that lets entrepreneurs,
              professionals and potential customers
              discover what your company does.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card featured-journey">

            <div className="journey-step">
              02
            </div>

            <div className="journey-icon">
              🤝
            </div>

            <h3>
              Connect
            </h3>

            <p>
              Meet people who can become partners,
              employees, collaborators, clients or
              supporters of your business.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card">

            <div className="journey-step">
              03
            </div>

            <div className="journey-icon">
              🚀
            </div>

            <h3>
              Grow
            </h3>

            <p>
              Turn meaningful connections into
              partnerships, projects, customers
              and new opportunities.
            </p>

          </div>

        </div>


        <div className="features-stats">

          <div>

            <h4>
              FREE
            </h4>

            <p>
              Join Nessefy
            </p>

          </div>

          <div>

            <h4>
              AI
            </h4>

            <p>
              Smarter discovery
            </p>

          </div>

          <div>

            <h4>
              ONE
            </h4>

            <p>
              Business ecosystem
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          HOW IT WORKS
      ====================================================== */}
      <section
        id="how"
        className="about"
      >

        <div className="about-content">

          <span className="about-tag">
            HOW IT WORKS
          </span>

          <h2>
            From
            <br />
            “We need to grow”
            <br />
            to
            <span className="how-highlight">
              “Let's connect.”
            </span>
          </h2>

          <p>
            Nessefy gives your company a place to connect
            with the people and ideas that can help move
            your business forward.
          </p>


          <div className="about-points">

            <div>

              <h4>
                01 — Create your company profile
              </h4>

              <p>
                Tell the ecosystem who you are, what your
                company does, what you are building and
                what you are looking for.
              </p>

            </div>


            <div>

              <h4>
                02 — Discover the ecosystem
              </h4>

              <p>
                Explore entrepreneurs, professionals,
                freelancers, investors, founders and
                businesses that could be relevant to you.
              </p>

            </div>


            <div>

              <h4>
                03 — Start building relationships
              </h4>

              <p>
                Connect with the right people and explore
                partnerships, talent, customers and
                opportunities.
              </p>

            </div>

          </div>

        </div>


        <div className="about-visual">

          <div className="orbit-card about-card-1">
            Founder
          </div>

          <div className="orbit-card about-card-2">
            Developer
          </div>

          <div className="orbit-card about-card-3">
            Investor
          </div>

          <div className="orbit-card about-card-4">
            Freelancer
          </div>

          <div className="orbit-card about-card-5">
            Partner
          </div>


          <div className="about-center-card company-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Grow Together
            </h3>

            <p>
              People • Ideas • Opportunities
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMMUNITY
      ====================================================== */}
      <section
        id="community"
        className="community-section"
      >

        <div className="community-content">

          <span className="community-tag">
            THE BUSINESS ECOSYSTEM
          </span>

          <h2>
            Your next opportunity
            <br />
            could be closer than you think.
          </h2>

          <p>
            Nessefy connects companies with the people
            behind the next generation of businesses —
            entrepreneurs, founders, freelancers,
            investors and professionals.
          </p>


          <div className="community-people">

            <div className="community-avatar">
              👨🏻‍💻
            </div>

            <div className="community-avatar">
              👩🏻‍💼
            </div>

            <div className="community-avatar">
              👨🏽‍🚀
            </div>

            <div className="community-avatar">
              👩🏽‍💻
            </div>

            <div className="community-avatar">
              👨🏻‍🎨
            </div>

            <div className="community-count">
              +
            </div>

          </div>


          <div className="community-labels">

            <span>
              Entrepreneurs
            </span>

            <span>
              Founders
            </span>

            <span>
              Professionals
            </span>

            <span>
              Freelancers
            </span>

            <span>
              Investors
            </span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ====================================================== */}
      <section className="contact-section final-company-cta">

        <div className="contact-content">

          <span className="contact-tag">
            YOUR NEXT OPPORTUNITY
          </span>

          <h2>
            Don't let your
            <br />
            company grow
            <br />
            alone.
          </h2>

          <h3>
            Build your network on
            <span>
              Nessefy.
            </span>
          </h3>

          <p>
            Join for free. Create your company profile.
            Start discovering people, ideas and opportunities
            that could take your business further.
          </p>

          <button
            className="primary-btn final-cta-button"
            onClick={goToRegister}
          >
            🏢 Join Nessefy
            <span>
              — It's Free
            </span>
          </button>

          <div className="final-free-line">

            ✓ Free to join

            <span>
              •
            </span>

            ✓ No credit card

            <span>
              •
            </span>

            ✓ Takes less than 2 minutes

          </div>

        </div>


        <div className="contact-card final-free-card">

          <div className="free-card-icon">
            ✓
          </div>

          <span>
            NO CATCH.
          </span>

          <h3>
            Nessefy is
            <br />
            <strong>
              100% FREE
            </strong>
            <br />
            to join.
          </h3>

          <p>
            Create your company presence and
            start connecting with the people
            who can help your business grow.
          </p>

          <button
            onClick={goToRegister}
            className="free-card-button"
          >
            Create Company Profile →
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ====================================================== */}
      <footer className="footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="footer-links">

          <span
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>

          <span
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}